import type { AuthPayload } from '@/types/auth'

const ACCESS_TOKEN_KEY = 'tp_access_token'
const PRIMARY_COLOR_KEY = 'tp_primary_color'

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function setAccessToken(token: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export function clearAccessToken(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(PRIMARY_COLOR_KEY)
}

export function getPrimaryColor(): string | null {
  return localStorage.getItem(PRIMARY_COLOR_KEY)
}

export function setPrimaryColor(color: string): void {
  localStorage.setItem(PRIMARY_COLOR_KEY, color)
}

export function applyPrimaryColor(color: string): void {
  document.documentElement.style.setProperty('--primary', color)
  document.documentElement.style.setProperty('--sidebar-primary', color)
  document.documentElement.style.setProperty('--ring', color)
}

export function getTokenPayload(): AuthPayload | null {
  const token = getAccessToken()
  if (!token) return null
  try {
    const raw = token.split('.')[1]
    if (!raw) return null
    // JWT usa base64url — converter para base64 padrão antes de decodificar
    const base64 = raw.replaceAll('-', '+').replaceAll('_', '/').padEnd(Math.ceil(raw.length / 4) * 4, '=')
    return JSON.parse(atob(base64)) as AuthPayload
  } catch {
    return null
  }
}

export function isAuthenticated(): boolean {
  const payload = getTokenPayload()
  if (!payload) return false
  return payload.exp * 1000 > Date.now()
}
